import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-business",
  "use": "icon-soc-business-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-business\">\r\n<g transform=\"translate(-176.128 -176.128) scale(1.344000)\">\r\n<path d=\"M288 192h448v128H288V192zm-64 160h576v480H224V352zm128 96v288h64V448h-64zm128 0v288h64V448h-64zm128 0v288h64V448h-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-business.svg
// module id = TO9S
// module chunks = 409